import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Users($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
		["path", { "d": "M16 3.128a4 4 0 0 1 0 7.744" }],
		["path", { "d": "M22 21v-2a4 4 0 0 0-3-3.87" }],
		["circle", { "cx": "9", "cy": "7", "r": "4" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiVXNlcnMuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCBJY29uIGZyb20gJy4vSWNvbi5zdmVsdGUnO1xuICBjb25zdCBpY29uTm9kZTogW3N0cmluZywgUmVjb3JkPHN0cmluZywgc3RyaW5nPl1bXSA9IFtbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTE2IDIxdi0yYTQgNCAwIDAgMC00LTRINmE0IDQgMCAwIDAtNCA0djJcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xNiAzLjEyOGE0IDQgMCAwIDEgMCA3Ljc0NFwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTIyIDIxdi0yYTQgNCAwIDAgMC0zLTMuODdcIiB9XSwgW1wiY2lyY2xlXCIsIHsgXCJjeFwiOiBcIjlcIiwgXCJjeVwiOiBcIjdcIiwgXCJyXCI6IFwiNFwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7aURBRGxDLENBQUM7T0FFTyxRQUE0QztHQUFLLE1BQU0sSUFBSSxHQUFHLEVBQUUsMkNBQTJDO0dBQU0sTUFBTSxJQUFJLEdBQUcsRUFBRSw2QkFBNkI7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLDRCQUE0QjtHQUFNLFFBQVEsSUFBSSxJQUFJLEVBQUUsR0FBRyxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUc7OztLQUNoUSxJQUFJOzs7Ozs7OztRQUVXLElBQUk7O0FBRDFCLENBQUMifQ==